/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { pluginsDeletePlugin } from "../funcs/pluginsDeletePlugin.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeletePluginRequest,
  DeletePluginSecurity,
} from "../models/operations/deleteplugin.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DeletePluginMutationVariables = {
  request: DeletePluginRequest;
  security?: DeletePluginSecurity | undefined;
  options?: RequestOptions;
};

export type DeletePluginMutationData = void;

export type DeletePluginMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deletePlugin plugins
 *
 * @remarks
 * Delete a plugin.
 */
export function useDeletePluginMutation(
  options?: MutationHookOptions<
    DeletePluginMutationData,
    DeletePluginMutationError,
    DeletePluginMutationVariables
  >,
): UseMutationResult<
  DeletePluginMutationData,
  DeletePluginMutationError,
  DeletePluginMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDeletePluginMutation(client, options),
    ...options,
  });
}

export function mutationKeyDeletePlugin(): MutationKey {
  return ["@gram/client", "plugins", "deletePlugin"];
}

export function buildDeletePluginMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DeletePluginMutationVariables,
  ) => Promise<DeletePluginMutationData>;
} {
  return {
    mutationKey: mutationKeyDeletePlugin(),
    mutationFn: function deletePluginMutationFn({
      request,
      security,
      options,
    }): Promise<DeletePluginMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(pluginsDeletePlugin(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
